import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { EducatorInterface } from "../../../common/interfaces/EducatorInterface";
import { QualificationInterface } from "../../../common/interfaces/QualificationInterface";
import { SectionEnum } from "../../../common/enums/SectionEnum";
import { AchievedCertificates } from "../components/establishmentManager/AchievedCertificates";
import { UnachievedEmployees } from "../components/establishmentManager/UnachievedEmployees";
import { Educators } from "../components/establishmentManager/Educators";
import { MetaInterface } from "../../../common/interfaces/MetaInterface";
import { JSX } from "react";
import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import { EstablishmentCertificates } from "../components/establishmentManager/EstablishmentCertificates";

interface Props {
    certificates?: {
        data?: CertificateInterface[];
        meta?: MetaInterface;
    };
    qualificationData?: QualificationInterface;
    educatorData?: {
        data?: EducatorInterface[];
        meta?: MetaInterface;
    };
    employeeData?: {
        data: EmployeeInterface[];
        meta?: MetaInterface;
    };
    educatorDataIsFetching: boolean;
    educatorDataIsLoading: boolean;
    certificateIsLoading: boolean;
    certificateIsFetching: boolean;
    employeeDataIsLoading: boolean;
    employeeDataIsFetching: boolean;
    qualificationIsLoading: boolean;
    sectionName: SectionEnum;
    totals: {
        totalActive?: number;
        totalExpired?: number;
    };
}

export const renderSectionContent = (props: Props): JSX.Element | null => {
    const {
        certificates,
        qualificationData,
        educatorData,
        employeeData,
        employeeDataIsFetching,
        employeeDataIsLoading,
        educatorDataIsFetching,
        educatorDataIsLoading,
        certificateIsLoading,
        certificateIsFetching,
        qualificationIsLoading,
        sectionName,
        totals,
    } = props;

    switch (sectionName) {
        case SectionEnum.ACHIEVED_CERTIFICATES:
            return (
                <AchievedCertificates
                    totals={totals}
                    certificates={certificates}
                    qualificationData={qualificationData}
                    certificateIsLoading={certificateIsLoading}
                    certificateIsFetching={certificateIsFetching}
                    qualificationIsLoading={qualificationIsLoading}
                />
            );
        case SectionEnum.EDUCATORS:
            return (
                <Educators
                    educatorData={educatorData}
                    educatorDataIsFetching={educatorDataIsFetching}
                    educatorDataIsLoading={educatorDataIsLoading}
                />
            );
        case SectionEnum.UNACHIEVED_CERTIFICATES:
            return (
                <UnachievedEmployees
                    employeeData={employeeData}
                    employeeDataIsFetching={employeeDataIsFetching}
                    employeeDataIsLoading={employeeDataIsLoading}
                    qualificationData={qualificationData}
                />
            );
        case SectionEnum.ESTABLISHMENTS_CERTIFICATE:
            return (
                <EstablishmentCertificates
                    certificates={certificates}
                    certificateIsLoading={certificateIsLoading}
                    certificateIsFetching={certificateIsFetching}
                    qualificationIsLoading={qualificationIsLoading}
                    qualificationData={qualificationData}
                />
            );
        default:
            return null;
    }
};
